export class ServiceResult<T> {
    result!: T;
    totalCount?: number;
    statusCode?: number;
    statusMessage?: string;
}
